<div class="search-suggest-products">
  <div class="d-flex justify-content-start headline">{{ 'suggest.products.headline' | translate }}</div>
  <ul>
    @for (productSku of products() | slice : 0 : maxAutoSuggests(); track productSku) {
    <ish-suggest-products-tile
      ishProductContext
      [sku]="productSku"
      [completeness]="1"
      [inputTerms$]="inputTerms$()"
      [deviceType]="deviceType()"
      (routeChange)="handleInputFocus()"
    />
    }
  </ul>
</div>
